import { AfterViewInit, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Subscription, catchError, map, of, take, tap } from 'rxjs';
import { AuthService } from '@auth0/auth0-angular';
import { initFlowbite } from 'flowbite';

import { ClipboardService } from '../../../core/services/common/clipboard-service.service';
import { CookiesService } from '../../../core/services/common/cookies.service';
import { MenuService } from '../../../core/services/common/menu.service';
import { MenuModel } from '../../../core/models/menu/menu.model';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {
  private subscription = new Subscription();

  picture: string | null | undefined = '';
  copyUserEmail: boolean = false;
  messageForCopyEmail: string = 'Copiar e-mail.';
  menu: MenuModel[] = [];
  filteredMenu: MenuModel[] = [];
  searchTerm: string = '';

  buttonVisibility: boolean = false;

  isColapseMenu: boolean = false;
  sidebarId: string = 'sidebar'; 

  constructor(
    private clipboardService: ClipboardService,
    private cookiesService: CookiesService,
    private menuService: MenuService,
    public auth0: AuthService,
  ) { }

  ngOnInit(): void {
    this.menu = this.menuService.getMenuItems();
    const menuSubscription = this.menuService.menuItems$.subscribe(items => {
      if (items && items.length > 0) {
        this.menu = items;
        if (this.searchTerm && this.searchTerm.trim() !== '') {
          this.onSearchMenu(this.searchTerm);
        }
      }
    });
    this.subscription.add(menuSubscription);
    this.fetchUserPicture();
  }

  ngAfterViewInit(): void {
    initFlowbite();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  fetchUserPicture(): void {
    const userPictureSubscription = this.auth0.user$.pipe(
      take(1),
      map(response => response?.picture),
      catchError(error => {
        console.error('Erro ao obter a imagem do usuário:', error);
        return of(null);
      })
    ).subscribe(picture => {
      this.picture = picture;
    });

    this.subscription.add(userPictureSubscription);
  }

  logoutAuth0(): void {
    this.auth0.logout({
      logoutParams: {
        returnTo: window.location.origin
      }
    });
  }

  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if (event.ctrlKey && event.key === 'k') {
      event.preventDefault();
      this.focarNoInputDePesquisa();
    }
  }

  focarNoInputDePesquisa(): void {
    const inputPesquisa = document.getElementById('default-search') as HTMLInputElement;
    if (inputPesquisa) {
      inputPesquisa.focus();
    }
  }

  copyEmail(): void {
    this.auth0.user$
      .pipe(
        tap((user) => {
          if (user?.email) {
            this.clipboardService.copyText(user?.email)
            this.messageForCopyEmail = 'E-mail copiado.'
            this.copyUserEmail = true;
          }
        })
      )
      .subscribe();
  }

  getMenuItems(): MenuModel[] {
    this.menu.forEach(item => {
      item.isHovered = false;
      item.subItemMenu?.forEach(subItem => subItem.isHovered = false);
    });
    return this.menu;
  }

  onHoverItem(item: MenuModel, isHovered: boolean): void {
    item.isHovered = isHovered;
  }

  toggleButtonVisibility(visible: boolean): void {
    setTimeout(() => {
      this.buttonVisibility = false;
    }, 7000)
    this.buttonVisibility = visible;
  }

  toggleSidebarId(): void {
    this.isColapseMenu = !this.isColapseMenu;
    this.sidebarId = this.sidebarId === 'sidebar' ? 'collapse-menu' : 'sidebar';
    console.log(this.sidebarId)
  }

  onSearchMenu(searchTerm: string): void {
    this.searchTerm = searchTerm;

    if (!searchTerm || searchTerm.trim() === '') {
      this.filteredMenu = [];
      setTimeout(() => {
        initFlowbite();
      }, 0);
      return;
    }

    const lowerSearchTerm = searchTerm.toLowerCase().trim();

    this.filteredMenu = this.menu
      .map(item => {
        const mainMatch = item.nameMainItemMenu.toLowerCase().includes(lowerSearchTerm);
        
        const filteredSubItems = item.subItemMenu?.filter(subItem =>
          subItem.name.toLowerCase().includes(lowerSearchTerm) ||
          subItem.description.toLowerCase().includes(lowerSearchTerm)
        );

        if (mainMatch) {
          return item;
        }

        if (filteredSubItems && filteredSubItems.length > 0) {
          return { ...item, subItemMenu: filteredSubItems };
        }

        return null;
      })
      .filter(item => item !== null) as MenuModel[];
  }
}
